// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagDefault extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagModel
	 */
	public render(data: SmartTagModel, version?: string): string {
		this.getData(data);
		
		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagModel): void{
		const title = data.title || data.subCategory || '';
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}
		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
